// src/components/iaDashboard/cards/AvgResponseTimeCard.jsx
import React from "react";

export default function AvgResponseTimeCard({ value }) {
  const minutes = value ?? 0;

  return (
    <div className="ia-card ia-card-time">
      <div className="ia-card-header">
        <span className="ia-card-label">Tempo médio de resposta</span>
      </div>
      <div className="ia-card-value">
        {minutes.toFixed ? minutes.toFixed(1) : minutes} min
      </div>
      <p className="ia-card-sub">
        Intervalo médio entre a primeira mensagem do usuário
        e a primeira resposta (IA + humano).
      </p>
    </div>
  );
}
